import z from 'zod';

import { projectUserRoleSchema } from './projectUser';

export type NotificationChannel = z.infer<typeof notificationChannelSchema>;
export const notificationChannelSchema = z.object({
  email: z.boolean(),
  sms: z.boolean(),
});

export type AlertReasons = z.infer<typeof alertReasonsSchema>;
export const alertReasonsSchema = z.object({
  sensorAlert: notificationChannelSchema.nullable().optional(),
  gatewayOffPower: notificationChannelSchema.nullable().optional(),
  weeklySummary: notificationChannelSchema.nullable().optional(),
});

export type UserNotificationSettings = z.infer<typeof userNotificationSettingsSchema>;
export const userNotificationSettingsSchema = z.object({
  projectId: z.number(),
  projectName: z.string(),
  notifications: alertReasonsSchema,
});

export type ProjectTeamMember = z.infer<typeof projectTeamMemberSchema>;
export const projectTeamMemberSchema = z.object({
  userProjectId: z.number(),
  userId: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phoneNr: z.string(),
  companyName: z.string(),
  isDistributorUser: z.boolean(),
  role: projectUserRoleSchema,
  expiryDate: z.string().optional().nullable(),
  alertReasons: alertReasonsSchema,
});
